let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTnhJ")).then(() => parcelRequire('jzOmA'));